import { updateCurrentSettings } from '@/app/editor/sidebar/utils/gfSnippetSettingLinks';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { arrayMap } from '@/app/utils/nativeArray';
import emitter from '@/emitter';

(function (jQuery) {
  jQuery.gfDropDown = function (element, options) {
    const defaults = {
      title: '',
      onOpen: function ($that) {},
      onClose: function ($that) {},
      onSelected: function (value, $element) {},
      onOpacity: function () {},
      offOpacity: function () {},
      flagDisabled: false,
      newOptionStyle: false,
      moreActions: false,
    };

    const _dataValue = [];

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _value;

    let $listSelect;
    let $itemListSelect;
    let value;

    let _dropdownTimeout;

    const _iconActive =
      '<svg class="help-me-name-it-bruh" height="8px" viewBox="0 0 10 8"><path d="M3.5,7.3L0,3.8l1-1l2.5,2.5L8.8,0l1,1L3.5,7.3z" style="fill: #1c1c25"/></svg>';

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.setTemplate();
      _this.onEvent();
      $element.on('value-change', function () {
        const value = $(this).attr('value');
        _this.setValue(value);
      });
    };

    this.renderOptionsList = (options) => {
      const liHtml = arrayMap(options, (option) => {
        const warningHtml = option.warning
          ? `<i class="icon icon-warn-triangle text-warning typo-icon-16 ml-4px gfDropDownSelect__warning"></i>`
          : '';

        return `<li class="gfDropDownSelect__option ${option.isActive ? 'active' : ''} ${
          option.warning ? 'warning' : ''
        }" value="${encodeURI(option.value)}" ${option.warning ? `warning="${option.warning}"` : ''}">
          <i class="icon icon-checked typo-icon-16 mr-1 gfDropDownSelect__checked"></i>
          <p class="text">${option.text}</p>
          ${warningHtml}
        </li>`;
      });

      return `<ul class="newOptionStyle">
        ${liHtml.join('')}
      </ul>`;
    };

    this.renderMoreActions = ($ul) => {
      const $template = $(_this.settings.moreActions.html);
      _this.settings.moreActions.applyEvents($template, _this.offOpen);
      $ul.append($template);
    };

    _this.renderSelect = function (value) {
      if (_this.settings.newOptionStyle) {
        const options = [];
        for (const i of value) {
          const $item = $(i);
          const itemValue = $item.attr('value');
          const warning = $item.attr('warning');
          options.push({
            isActive: itemValue == _value,
            value: itemValue,
            text: $item.text(),
            warning: warning || false,
          });
        }
        return _this.renderOptionsList(options);
      }

      let _template = '<ul>';
      for (let i = 0; i < value.length; i++) {
        const prepend = $(value[i]).attr('prepend') || '';
        const append = $(value[i]).attr('append') || '';
        const text = $(value[i]).text();
        const customClass = $(value[i]).attr('custom-class') || '';
        const activeClass = $(value[i]).attr('value') == _value ? 'active' : '';
        _template += `<li class="${activeClass} ${customClass}" append="${append}" prepend="${encodeURI(
          prepend,
        )}" value="${encodeURI($(value[i]).attr('value'))}">${prepend}<div class="text">${text}</div>${append}</li>`;
      }
      _template += '</ul>';
      return _template;
    };

    this.renderWarningTooltip = function ($warning) {
      const $b = $element.next('.gfDropDown').find('span b');
      const warning = $warning.attr('warning');
      $b.addClass(['d-flex', 'align-items-center']);

      $b.append(`
        <i class="p-0 warning__wrapper">
          <p class="p-1 pr-12px body-12-medium text-light1 warning__tooltip">
            <i class="warning__tooltip-text">${warning}</i>
          </p>
          <i class="icon-warn-triangle text-warning typo-icon-16 ml-4px mr-4px"></i>
        </i>
      `);
    };

    this.setTemplate = function () {
      let _iconTemplate = '';
      let dataIcon = 'none';
      const icon = typeof $element.attr('icon') === 'undefined' ? '' : $element.attr('icon');
      value = $element.children('option');
      const customClass = $element.attr('custom-class') || '';
      _value = typeof $element.attr('value') === 'undefined' ? '' : $element.attr('value');
      if (_value === '') {
        _value = typeof $element.attr('default_value') === 'undefined' ? '' : $element.attr('default_value');
      }
      const desc = typeof $element.attr('data-description') === 'undefined' ? '' : $element.attr('data-description');
      const disable = typeof $element.attr('data-disable') === 'undefined' ? '' : $element.attr('data-disable');

      if (disable === 'true') {
        _this.disable();
      }
      //  && !$element.hasClass("gf_gs-select-render")
      if (_value === '') {
        _value = $(value[0]).attr('value');
      }
      const valueLength = value.length;
      const optionValues = [];
      for (var i = 0; i < valueLength; i++) {
        const $el = $(value[i]);
        optionValues.push($el.attr('value'));
      }
      $element.attr('value', _value).val(_value);
      // When value not exist option values
      if (_value && !optionValues.includes(_value)) {
        _value = $(value[0]).attr('value');
        $element.attr('value', _value).val(_value).trigger('input-change');
      }
      const $elId = $element.attr('id');
      let gfDropDownId = '';
      if ($elId) {
        gfDropDownId = `gfDropDown_${$elId}`;
      }
      if (icon === 'true') {
        _iconTemplate = '<i class="icon icon-arrow-right"></i>';
        dataIcon = true;
      }

      let _template = `<div class="gfDropDown" id="${gfDropDownId}">`;
      if (_this.settings.title === '') {
        // SUPPORT GLOBAl STYLE
        _template += '<div class="gfSGSubTitle m-0"></div>';
      } else {
        _template += '<div class="gfSGSubTitle">' + _this.settings.title + '</div>';
        _template += '<div class="gfSGclear"></div>';
      }
      _template += '<div class="gfDropDownIcon">' + _iconTemplate + '</div>';
      _template += '<div class="gfDropDownSelect" data-icon="' + dataIcon + '">';
      _template += '<div class="gfDropDownBody">';
      let $warning = null;
      const templateArray = new Array(valueLength);
      for (var i = 0; i < valueLength; i++) {
        const $el = $(value[i]);
        if ($el.attr('value') == _value) {
          const prepend = $el.attr('prepend') || '';
          const hasPrepend = prepend ? 'has-prepend' : '';
          const append = $el.attr('append') || '';
          const hasAppend = append ? 'has-append' : '';
          const classes = [hasPrepend, hasAppend];

          if ($el.attr('warning')) {
            $warning = $el;
          }
          const textHtml = _this.settings.newOptionStyle
            ? `<i class="gfDropDown__value-text">${$el.text()}</i>`
            : $el.text();

          templateArray[i] = `<span class="gfDropDown__value ${classes.join(' ')} ${customClass}">
            ${prepend}
            <b data-value="${encodeURI(_value)}">
              ${textHtml}
            </b>
            <i class="icon icon-arrow-right"></i>
          </span>`;
        }
      }
      _template += templateArray.join('');
      _template += _this.renderSelect(value);
      _template += '</div>';
      if (desc === '') {
        _template += '<div class="gfDesc" data-desc="none">' + desc + '</div>';
      } else {
        _template += '<div class="gfDesc">' + desc + '</div>';
      }
      _template += '</div>';
      _template += '</div>';
      $element.after(_template);

      const $gfDropDown = $element.next('.gfDropDown');
      $gfDropDown.find('ul').addClass(customClass);
      if (value.length >= 6) {
        $gfDropDown.find('ul').addClass('optiscroll').optiscroll();
      }
      if ($warning) {
        _this.renderWarningTooltip($warning);
      }
      if (_this.settings.moreActions) {
        _this.renderMoreActions($gfDropDown.find('ul'));
      }
      return false;
    };

    this.setSelect = function ($value) {
      if (_this.settings.newOptionStyle) {
        const options = arrayMap($value, (item) => ({
          isActive: item.styleName == _value,
          value: item.styleName,
          text: item.googleName,
        }));
        return _this.renderOptionsList(options);
      }
      let _template = '<ul>';
      const $valuesLength = $value.length;
      for (let i = 0; i < $valuesLength; i++) {
        if ($value[i].googleName == _value) {
          _template += '<li class="active" value="' + $value[i].googleName + '">' + $value[i].styleName + '</li>';
        } else {
          _template += '<li value="' + $value[i].googleName + '">' + $value[i].styleName + '</li>';
        }
      }
      _template += '</ul>';

      const $gfDropDown = $element.next();
      const $bodyDropDown = $gfDropDown.find('.gfDropDownBody');
      $bodyDropDown.find('ul').remove();
      $bodyDropDown.append(_template);
      if ($valuesLength >= 6) {
        $gfDropDown.find('ul').addClass('optiscroll').optiscroll();
      }
      $listSelect = $gfDropDown.find('ul', '.gfDropDownSelect');
      const $btnSelect = $gfDropDown.find('span', '.gfDropDownSelect');
      $itemListSelect = $listSelect.find('li');

      _this.onEvent();
      if (_this.settings.moreActions) {
        _this.renderMoreActions();
      }
    };

    this.setHighlight = function () {
      const $gfDropDown = $element.next();
      const $btnSelect = $gfDropDown.find('.gfDropDownSelect span');
      $btnSelect.addClass('highlight');
      $gfDropDown.off('click.closeHighlight').on('click.closeHighlight', function () {
        $btnSelect.removeClass('highlight');
        $gfDropDown.off('click.closeHighlight');
      });
    };

    this.onOpen = function () {
      if (_this.settings.flagDisabled) {
        return;
      }
      const $allDropDown = $gfLeftSideBar.find('.gfDropDown');
      for (let i = 0; i < $allDropDown.length; i++) {
        const $input = $($allDropDown[i]).prev();
        $input.data('gfdropdown').offOpen();
      }
      _this.settings.onOpen($element);

      const $gfDropDown = $element.next();
      $gfDropDown.css({
        'z-index': '99',
      });

      const $listSelect = $gfDropDown.find('.gfDropDownSelect ul');
      const $bodyDropDown = $gfDropDown.find('.gfDropDownBody');

      $listSelect.addClass('active');
      $bodyDropDown.addClass('show');

      let top = 32; // Height Span;
      if ($bodyDropDown.offset().top + $listSelect.height() + 32 > $(window).height()) {
        top = $listSelect.height() * -1;
      }
      $listSelect.css({
        top: 'calc(100% - 8px)',
      });

      $gfLeftSideBar.data('gfleftsidebar').disableScroll();
      $gfLeftSideBar.off('mousedown.dropdown').on('mousedown.dropdown', function (e) {
        const $target = jQuery(e.target);
        if ($target.closest('.gfDropDownBody').length == 0) {
          _this.offOpen();
        }
      });
      $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('iframeDropDownBody');

      setTimeout(function () {
        $gryffBody
          .find('.iframeDropDownBody')
          .off('mousedown.removeBackground')
          .on('mousedown.removeBackground', function () {
            $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('iframeDropDownBody');
            _this.offOpen();
          });
      }, 0);

      return false;
    };

    this.offOpen = function () {
      _this.settings.onClose($element);
      const $gfDropDown = $element.next();
      $gfDropDown.css({
        'z-index': '50',
      });
      const $listSelect = $gfDropDown.find('.gfDropDownSelect ul');
      const $bodyDropDown = $gfDropDown.find('.gfDropDownBody');

      $listSelect.removeClass('active');
      $bodyDropDown.removeClass('show');
      $gfLeftSideBar.data('gfleftsidebar').enableScroll();
      $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('iframeDropDownBody');
      return false;
    };

    this.setValue = function (value) {
      _this.offOpen();
      _value = value;

      const $gfDropDown = $element.next();
      const $btnSelect = $gfDropDown.find('.gfDropDownSelect span');
      $listSelect = $gfDropDown.find('.gfDropDownSelect ul');

      $listSelect.children('.active').removeClass('active');
      const $elementActive = $listSelect.find('li[value="' + encodeURI(value) + '"]');
      $listSelect.find('li').each(function () {
        if (jQuery(this).attr('value') != encodeURI(value)) {
          jQuery(this).removeClass('active');
        }
      });

      $elementActive.addClass('active');

      const $elText = $elementActive.find('.text');
      const text = $elText.text();
      if (!_this.settings.newOptionStyle) {
        $elText.html(text);
      }

      $btnSelect.find('b').html(text);
      $btnSelect.find('b').attr('data-value', encodeURI(value));

      $element.attr('value', value).val(value).trigger('on-require');
      updateCurrentSettings($element.attr('id'), value);
      return false;
    };

    this.onChangeValue = function (value) {
      _value = value;
      $element.attr('value', value).val(value).trigger('on-require');
      updateCurrentSettings($element.attr('id'), value);
      _this.settings.onSelected(value, $element);
    };

    this.clearValue = function () {
      _this.setValue('');
    };

    _this.onEvent = function () {
      const $gfDropDown = $element.next();
      const $btnSelect = $gfDropDown.find('.gfDropDownSelect span');
      $listSelect = $gfDropDown.find('.gfDropDownSelect ul');
      $itemListSelect = $gfDropDown.find('.gfDropDownSelect ul li');

      $btnSelect.off('click').on('click', function () {
        if (_this.settings.flagDisabled) {
          return;
        }
        if ($listSelect.hasClass('active')) {
          _this.offOpen();
        } else {
          _this.onOpen();
        }
      });

      $itemListSelect.off('click').on('click', function () {
        if (_this.settings.flagDisabled) {
          return;
        }
        const $el = jQuery(this);

        const warning = $el.attr('warning');
        if (warning) {
          return;
        }

        const valueChange = decodeURI($el.attr('value'));

        $listSelect.find('li.active').removeClass('active');

        const $elementActive = $listSelect.find(`li[value="${encodeURI(valueChange)}"]`);

        const $elText = $elementActive.find('.text');
        const text = _this.settings.newOptionStyle
          ? `<i class="gfDropDown__value-text">${$el.text()}</i>`
          : $elText.text();
        $elementActive.addClass('active');

        $btnSelect.find('b').html(text);
        const prepend = $elementActive.attr('prepend');
        $btnSelect.removeClass('has-prepend');
        $btnSelect.find('.prepend').remove();
        if (prepend) {
          $btnSelect.addClass('has-prepend');
          $btnSelect.prepend(decodeURI(prepend));
        }

        $btnSelect.find('b').attr('data-value', encodeURI(valueChange));

        const valBeforeChange = $element.val();
        _this.onChangeValue(valueChange);
        $element.trigger('input-change', [{ valBeforeChange: valBeforeChange }]).trigger('history-change');

        _this.offOpen();

        return false;
      });
      return false;
    };
    /**
     * disabled
     */
    this.disable = function () {
      _this.settings.flagDisabled = true;
      $element.attr('data-disable', 'true').val('true');
      $element.next('.gfDropDown').find('.gfDropDownBody').addClass('disabled');
    };

    /**
     * enabled
     */
    this.enable = function () {
      _this.settings.flagDisabled = false;
      $element.attr('data-disable', 'false').val('false');
      $element.next('.gfDropDown').find('.gfDropDownBody').removeClass('disabled');
    };

    /**
     * toggleDisabled
     */
    this.toggleDisable = function () {
      if (_this.settings.flagDisabled) {
        //current is disabled => enabled
        this.enable();
      } else {
        this.disable();
      }
    };

    this.init();
  };
  jQuery.fn.gfDropDown = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfdropdown')) {
        const plugin = new jQuery.gfDropDown(this, options);
        jQuery(this).data('gfdropdown', plugin);
      }
    });
  };
})(jQuery);
